import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { RefuseLeadsType } from "types/enums";

export const useRefuseLeadsTypeSelectOptions = () => {
    const { t } = usePaldockTranslation("general");

    const options = Object.values(RefuseLeadsType).map((value) => ({
        label: t(`refuse_leads_type.${value}`),
        value: value,
    }));

    return { options, loading: false, error: null };
};
